export default __webpack_public_path__ + "static/spiritual-christian-paul-1-f0850ece486400f88136ce7445caa588.jpg";